import {ReportGpsLocationHistoryModel} from "../../models/reports/ReportGpsLocationHistoryModel";

export class ReportGpsLocationHistoryCtrl {
    public static $inject = ['$scope','ReportGpsLocationHistoryModel'];
    constructor(public $scope:any, public model:ReportGpsLocationHistoryModel) {
        $scope.vm = this;
        this.$scope.$watch(() => [this.model.name,this.model.location, this.model.assetType,this.model.department,this.model.disposalStatus,this.model.checkedinStatus,this.model.missing],(newValue: string, oldValue: string) => {
            this.model.getCount();
        },true);
    }
}
